(function() {
  var searchMessage = document.querySelector('.js-searchMessage');
  var searchOutput = document.querySelector('.js-searchOutput');

  var pageSize = 64;
  var currentPage = 1;

  var params = new URLSearchParams(window.location.search);
  var query = params.get('q');

  if (!query || query === '') {
    return;
  }

  function renderPaginationBtn() {
    var buttonWrapper = document.createElement('div');

    buttonWrapper.classList.add('grid__item', 'one-whole', 'grid--center', 'js-paginationBtn');
    searchOutput.appendChild(buttonWrapper);

    var button = document.createElement('button');
    button.type = 'button';
    button.classList.add('btn');
    button.textContent = window.theme.strings.searchViewMore;
    buttonWrapper.appendChild(button);

    button.addEventListener('click', function() {
      getPage();
    });
  }

  function processResults(results, lastPage) {
    if (results.length > 0) {
      searchMessage.remove();

      var products = results.map(function(product) {
        var prices = product.variant_prices.map(function(price) {
          return price * 100;
        });

        const compareAtPrices = product.variant_list_prices.map(function(price) {
          return price * 100;
        });

        return {
          compare_at_prices: compareAtPrices,
          image_responsive_url: product.image,
          image_aspect_ratio: 1,
          prices: prices,
          title: product.name,
          url: product.url,
        };
      });

      var existingPaginationBtn = searchOutput.querySelector('.js-paginationBtn');

      if (existingPaginationBtn) {
        existingPaginationBtn.remove();
      }

      searchOutput.insertAdjacentHTML('beforeend', window.theme.buildProductGridItem(
        products,
        'small--one-half medium-up--one-quarter',
        4,
        'square',
      ));

      if (!lastPage) {
        renderPaginationBtn();
      }
    } else {
      searchMessage.textContent = window.theme.strings.searchNoResults;

      return;
    }
  }

  function getPage() {
    return window.Clerk(
      'call',
      'search/search',
      {
        labels: ['Search page'],
        query,
        limit: pageSize,
        offset: (currentPage - 1) * pageSize,
        attributes: [
          'image',
          'name',
          'variant_list_prices',
          'variant_prices',
          'url',
        ],
      },
      function(response) {
        var lastPage;

        if (response.hits > currentPage * pageSize) {
          currentPage += 1;
          lastPage = false;
        } else {
          lastPage = true;
        }

        processResults(response.product_data, lastPage);
      },
      function(error) {
        console.error(error);
      }
    );
  }

  getPage();
})();